import * as React from "react";
import { toast, ToastContainer } from "react-toastify";
import Modal from 'react-awesome-modal';

import withServices from "../../../../HOCs/withServices";
import NavBar from "../../../../components/CustomNav/CustomNav.Component";
import DatePicker from "../../../../components/DatePicker/DatePickerComponent";
import Calendly from '../../../../components/CalendlyBooking/CalendlyBooking.Component';
import schoolBg from "../../../../assets/images/parentreg/schoolbg.jpg";
import resultsBg from "../../../../assets/images/parentreg/results-bg.jpg";
import pixl from "../../../../assets/images/parentreg/pixlstrip.jpg";
import plexIcon from "../../../../assets/images/plex_symbol.png"
import plexlogo from "../../../../assets/images/plex_new.png"
import pixllogo from "../../../../assets/images/parentreg/pixllogo.png"
import pixlLogoBlack from "../../../../assets/images/pixl-logo-black.png"

import {
  Container,
  FormContainer,
  FormWrapper,
} from "../../Common/Common.styles";
import { Heading, InputWrapper } from "../Registration/SchoolRegistration.styles";

import {
  Row,
  Section,
  Col2,
  TooltipParagraph
} from "../../Parent/Registration/ParentRegistration.styles";

import { Grid, Filter, BorderButton, PixlFooter } from './PixlRegistration.styles';

import { currentBaseUrl, saveItem } from "../../../../common/services";
import {
  CURRENTUSERID,
  CURRENTUSERNAME,
  PROFILEKEY,
  SUBSCRIPTIONKEY,
  TOKENKEY,
  CURRENTDESIGNATION,
} from "../../../../common/constants";

interface IProps {
  services?: any;
  history?: any;
  match?: any;
}

const filters = [
    "Confidence",
    "Stress & Strain",
    "Retaining & Recalling Information",
    "Organisation & Time Management",
    "Focus & Motivation",
    "Sleep & Tiredness",
    "Exam Anxiety"
]

const PACKAGE_ID = 18;

class PixlRegistration extends React.Component<IProps> {
  public state = {
    password: "",
    institutiontype: null,
    email: "",
    schoolname: "",
    phone: "",
    dateObj: null as any,
    schoolyear: null,
    startDate: "",
    institutionTypes: [] as any,
    calendlyModal: false,
  };

  private registerRef = React.createRef<HTMLDivElement>();

  constructor(props) {
    super(props);
    this.navigate = this.navigate.bind(this);
    this.registerSchool = this.registerSchool.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchUserInfo = this.fetchUserInfo.bind(this);
    this.registerSchool = this.registerSchool.bind(this);
  }

  public async componentDidMount() {
    const {
      history,
      services: {
        isUserLoggedIn,
        institutionsAPI,
        currentBaseUrl,
        currentDesignation,
        isUserUpgraded,
      },
    } = this.props;

    if (isUserLoggedIn) {
      if (isUserUpgraded) {
        this.navigate("school/home");
      }
    }

    const typesRes = await institutionsAPI.getInstitutionTypes();
    if (typesRes.ok) {
      const institutionTypes = typesRes.data.types;
      this.setState({ institutionTypes });
    }

    console.log(typesRes);
    console.log(this.props);
  }

  public onScroll = (target) => {
    console.log({ target });
    if (target.current === null) {
      console.log("Not scrolling...");
      return;
    }
    console.log("scrolling...", target.current.offsetTop);
    window.scroll({
      left: 0,
      top: target.current.offsetTop,
      behavior: "smooth",
    });

    console.log({ window });
    // window.scrollTo(0, 0);
  };

  public toggleCalendly = () => {
    const { calendlyModal } = this.state;
    this.setState({ calendlyModal: !calendlyModal });
  };

  public handleChange(event) {
    const currentField = event.target.dataset.arg;
    this.state[currentField] = event.target.value;
    console.info(this.state[currentField]);
  }

  public ageChangeHandler = (dateObj) => {
    const startDate = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ dateObj, startDate });
  };

  public navigate(destination) {
    const { history } = this.props;
    history.push(destination);
  }

  public async registerSchool(event) {
    event.preventDefault();
    const {
      email,
      schoolname,
      password,
      schoolyear,
      startDate,
      institutiontype,
    } = this.state;

    const item = {
      email,
      institution_type: institutiontype,
      password,
      school_name: schoolname,
      selected_package: PACKAGE_ID,
    };

    const regRes = await this.props.services.institutionsAPI.signUpInstitutionPromotional(
      item
    );

    if (regRes.ok) {
      saveItem(PROFILEKEY, regRes.data.profile);
      saveItem(SUBSCRIPTIONKEY, regRes.data.subscription);
      saveItem(TOKENKEY, regRes.data.token);
      saveItem(CURRENTDESIGNATION, regRes.data.designation);
      saveItem(PROFILEKEY, regRes.data.profile);
      saveItem(CURRENTUSERNAME, regRes.data.userinfo.username);
      saveItem(CURRENTUSERID, regRes.data.userinfo.id);
      this.props.history.push(`${currentBaseUrl()}home`);
    } else {
      toast.error("Sign up failed, check your details!");
    }
  }

  public async fetchUserInfo() {
    // coming
    const infoRes = await this.props.services.adminAPI.fetchUserInfo();
    console.log(infoRes);
    if (infoRes.ok) {
      // breakdown
    } else {
      window.location.reload();
    }
  }

  public renderCalendlyPopup = () => {
    return (
      <Modal
        visible={this.state.calendlyModal}
        effect="fadeInDown"
        onClickAway={this.toggleCalendly}
      >
        <Calendly url="https://calendly.com/performance_learning/welcome-pixl-school-to-plex?background_color=2a2a2a&text_color=ffffff&primary_color=acff24" />
      </Modal>
    );
  };

  public render() {
    const { institutionTypes } = this.state;
    return (
      <Container height="auto" background={schoolBg}>
        <ToastContainer />
        <NavBar />
        {this.renderCalendlyPopup()}
        <Section
          backgroundImage="linear-gradient(45deg, rgba(36, 230, 248, .8), rgba(36, 230, 248, 0.85), rgba(172, 255, 36, 0.85))"
          height="100vh"
          justify="flex-start"
          ref={this.registerRef}
        >
          <div style={{ margin: "3em 0 5em 0" }}>
            <Heading
              textTransform="none"
              width="100%"
              color="#000"
              fontSize="52px"
            >
              DEAR{" "}
              <img
                style={{ height: "74px", marginTop: "-15px" }}
                src={pixlLogoBlack}
              />{" "}
              SCHOOL, WELCOME TO PERFORMANCE LEARNING
            </Heading>
            <Heading width="100%" color="#000" fontSize="24px">
              THIS IS PERFORMANCE LEARNING'S TECHNOLOGY CREATED <br /> TO
              ENHANCE META-COGNITION &amp; SELF REGULATION
            </Heading>
          </div>
          <Row
            style={{ maxWidth: "1024px", boxShadow: "10px 10px 64px #0a0a0a" }}
            wrap="wrap"
            width="80%"
            justify="center"
          >
            <Col2 height="640px" background={schoolBg}>
              <div
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundColor: "#00000085",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "flex-end",
                  padding: "2em",
                  minWidth: "400px",
                }}
              >
                <Heading style={{ textAlign: "left" }}>
                  Book a call with us
                </Heading>
              </div>
            </Col2>
            <Col2 height="640px">
              <Calendly
                height="640px"
                width="100%"
                url="https://calendly.com/performance_learning/welcome-pixl-school-to-plex?background_color=2a2a2a&text_color=ffffff&primary_color=acff24"
              />

              {/* <FormContainer>
                <FormWrapper width="100%">
                  <p
                    style={{
                      textAlign: "left",
                      fontSize: "30px",
                      width: "100%",
                      padding: "0 16px",
                    }}
                    className="designation-title"
                  >
                    Register School
                  </p>
                  <form onSubmit={this.registerSchool}>
                    <InputWrapper>
                      <TooltipParagraph>
                        Who would you like PLEX for?
                        <a href="#">Multiple year groups?</a>
                        <span className="hover-tooltip">
                          Pick one year group, you can register learners with different year groups in PLEX itself (PLEX will show you how).
                        </span>
                      </TooltipParagraph>
                      <select
                        name="type"
                        data-arg="institutiontype"
                        required={true}
                        className="custom-select"
                        placeholder="Please choose your type of institution"
                        onChange={this.handleChange}
                      >
                        <option value="">Who would you like PLEX for?</option>
                        {institutionTypes.map((el) => (
                          <option value={el.id} key={`type-${el.id}`}>
                            {el.Name}
                          </option>
                        ))}
                      </select>
                    </InputWrapper>

                    <InputWrapper>
                      <p>Email</p>
                      <input
                        type="email"
                        id="email"
                        className="custom-textfield"
                        placeholder="Email Address"
                        required={true}
                        data-arg="email"
                        onChange={this.handleChange}
                      />
                    </InputWrapper>

                    <InputWrapper>
                      <p>Institution Name</p>
                      <input
                        type="text"
                        id="schoolname"
                        className="custom-textfield"
                        placeholder="School Name"
                        required={true}
                        data-arg="schoolname"
                        onChange={this.handleChange}
                      />
                    </InputWrapper>

                    <InputWrapper>
                      <p>Password</p>
                      <input
                        type="password"
                        id="password"
                        className="custom-textfield"
                        placeholder="Password"
                        required={true}
                        data-arg="password"
                        onChange={this.handleChange}
                      />
                    </InputWrapper>

                    <button
                      style={{ color: "#000", width: "100%" }}
                      className="green-button register-parent"
                      type="submit"
                    >
                      Register
                    </button>
                    <p className="already-registered">
                      ALREADY REGISTERED?{" "}
                      <span onClick={this.navigate.bind(this, "/login")}>
                        LOGIN HERE
                      </span>
                    </p>
                  </form>
                </FormWrapper>
              </FormContainer> */}
            </Col2>
          </Row>
        </Section>

        <Section
          justify="center"
          backgroundImage={`url(${resultsBg})`}
          height="55vh"
        >
          <Heading textTransform="none" width="100%" fontSize="32px">
            FOR ALL <span style={{ color: "#ff4e1e" }}>PiXL SCHOOLS</span> THE
            USE OF PERFORMANCE LEARNING'S DIAGNOSIS <br /> AND REPORTING TECHNOLOGY HAS BEEN
            MADE AVAILABLE
          </Heading>
          <button
            style={{
              padding: "1em 2em",
              minWidth: "360px",
              marginTop: "2em",
            }}
            className="green-button register"
            onClick={this.onScroll.bind(this, this.registerRef)}
          >
            Book a call
          </button>
        </Section>

        <Section backgroundColor="#101010">
          <Heading
            width="100%"
            style={{
              color: "var(--blue)",
              fontSize: "32px",
              margin: "2em 0 1.5em 0",
            }}
          >
            PERFORMANCE LEARNING'S 7 PILLARS OF LEARNING &amp; SELF REGULATION
          </Heading>
          <Grid>
            {filters.map((item, i) => (
              <Filter key={`filter-${i}`}>
                <img className="plex-icon" src={plexIcon} />
                <span>{item}</span>
              </Filter>
            ))}
          </Grid>

          <Heading
            width="100%"
            style={{
              color: "var(--green)",
              fontSize: "32px",
              margin: "2em 0 1.5em 0",
            }}
          >
            DIAGNOSE. UNDERSTAND. INTERVENE. TRANSFORM
          </Heading>
          <button
            style={{
              padding: ".75em 2em",
              minWidth: "360px",
              margin: "1em 0 2em 0",
            }}
            className="green-button register"
            onClick={this.onScroll.bind(this, this.registerRef)}
          >
            Book a call
          </button>
        </Section>

        <Section padding="0" height="60vh" backgroundImage={`url(${pixl})`}>
          <PixlFooter>
            <div>
              <Heading>Questions? Talk to us.</Heading>
              <BorderButton onClick={this.toggleCalendly}>
                Book a call
              </BorderButton>
            </div>
            <div>
              <img
                style={{ display: "block", width: "200px" }}
                src={plexlogo}
                alt=""
              />
              <span
                style={{
                  fontWeight: "bold",
                  fontStyle: "italic",
                  textAlign: "center",
                  marginBottom: "1em",
                }}
              >
                IN PARTNERSHIP WITH
              </span>
              <img
                style={{ display: "block", width: "100px" }}
                src={pixllogo}
                alt=""
              />
            </div>
          </PixlFooter>
        </Section>
      </Container>
    );
  }
}

export default withServices(PixlRegistration);



// WEBPACK FOOTER //
// ./src/pages/Onboard/Institution/PiXLRegistration/PixlRegistration.tsx